export default "__VITE_ASSET__BvhGSPIy__"